module.exports = __webpack_public_path__ + "img/party.e560bfb0.png";